import UsStates from "../../../../lib/usStates";
import { Option } from "../../types/fieldTypes";

export const defaultDescription =
  "Please input at least 3 characters for address look up";

export const usStateOptions: Option<number>[] = Object.entries(UsStates)
  .filter(([_, value]) => typeof value === "number")
  .map(([label, value]) => ({
    label,
    value: value as number,
  }))
  .sort((a, b) => {
    if (a.label < b.label) {
      return -1;
    } else if (a.label > b.label) {
      return 1;
    }

    return 0;
  });
